import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import format from "date-fns/format";
import { createSupabaseClient } from "../../../hooks/useSupabase";

export type RadiologistCutoff = {
  centerUserId: string;
  date: string;
  type: string;
  cutoffMinutesFromMidnight: number | null;
};

const useRadiologistCutoffs = (
  centerId: string,
  weekStart: Date,
  weekEnd: Date,
) => {
  const supabase = useMemo(() => createSupabaseClient(), []);

  const weekStartISO = format(weekStart, "yyyy-MM-dd");
  const weekEndISO = format(weekEnd, "yyyy-MM-dd");

  return useQuery({
    queryKey: [
      "radiologist-cutoffs",
      { centerId, weekStart: weekStartISO, weekEnd: weekEndISO },
    ],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("radiologist_read_cutoffs")
        .select("center_user_id, date, type, cutoff_minutes_from_midnight")
        .eq("center_id", centerId)
        .gte("date", weekStartISO)
        .lte("date", weekEndISO);

      if (error) throw new Error(error.message);

      return (data ?? []).map((row) => ({
        centerUserId: row.center_user_id,
        date: row.date?.slice(0, 10) ?? row.date,
        type: row.type,
        cutoffMinutesFromMidnight: row.cutoff_minutes_from_midnight,
      })) as RadiologistCutoff[];
    },
    enabled: !!centerId,
  });
};

export default useRadiologistCutoffs;
